// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_bb66b05","container":"_2797865"};